import { Module } from 'vuex'
import { OrdersState, Order, OrderStatus, CartItem, ShippingAddress, PaymentMethod } from '@/types'

const MOCK_ORDERS: Order[] = [
  {
    id: 'ORD-001',
    customer: { id: '1', name: 'Demo User', email: 'demo@jengahills.com', role: 'customer', createdAt: '2024-01-10T00:00:00Z' },
    items: [],
    status: 'delivered',
    paymentMethod: 'mobile_money',
    paymentStatus: 'paid',
    shippingAddress: { fullName: 'Demo User', phone: '+250700000000', street: 'KN 5 Rd', city: 'Kigali', region: 'Kigali' },
    subtotal: 63000,
    shippingFee: 5000,
    total: 68000,
    createdAt: '2024-01-10T09:00:00Z',
    updatedAt: '2024-01-12T14:00:00Z'
  }
]

const orders: Module<OrdersState, unknown> = {
  namespaced: true,

  state: (): OrdersState => ({
    list: [],
    current: null,
    loading: false,
    error: null
  }),

  getters: {
    orderById: (state) => (id: string) => state.list.find(o => o.id === id)
  },

  mutations: {
    SET_LOADING (state, loading: boolean) { state.loading = loading },
    SET_ERROR (state, error: string | null) { state.error = error },
    SET_ORDERS (state, orders: Order[]) { state.list = orders },
    SET_CURRENT (state, order: Order | null) { state.current = order },
    ADD_ORDER (state, order: Order) { state.list.unshift(order) },
    UPDATE_STATUS (state, { id, status }: { id: string; status: OrderStatus }) {
      const order = state.list.find(o => o.id === id)
      if (order) {
        order.status = status
        order.updatedAt = new Date().toISOString()
      }
    }
  },

  actions: {
    async fetchOrders ({ commit }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        commit('SET_ORDERS', MOCK_ORDERS)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async placeOrder ({ commit }, payload: {
      items: CartItem[]
      shippingAddress: ShippingAddress
      paymentMethod: PaymentMethod
    }) {
      commit('SET_LOADING', true)
      try {
        await new Promise(resolve => setTimeout(resolve, 1000))
        const subtotal = payload.items.reduce((s, i) => s + i.product.price * i.quantity, 0)
        const shippingFee = 5000
        const newOrder: Order = {
          id: 'ORD-' + Date.now(),
          customer: { id: '1', name: 'Demo User', email: 'demo@jengahills.com', role: 'customer', createdAt: new Date().toISOString() },
          items: payload.items.map(i => ({ product: i.product, quantity: i.quantity, unitPrice: i.product.price })),
          status: 'pending',
          paymentMethod: payload.paymentMethod,
          paymentStatus: 'pending',
          shippingAddress: payload.shippingAddress,
          subtotal,
          shippingFee,
          total: subtotal + shippingFee,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
        commit('ADD_ORDER', newOrder)
        commit('SET_CURRENT', newOrder)
        return newOrder
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateOrderStatus ({ commit }, payload: { id: string; status: OrderStatus }) {
      await new Promise(resolve => setTimeout(resolve, 300))
      commit('UPDATE_STATUS', payload)
    }
  }
}

export default orders
